const { _startApplePaySession, _openAppleWalletApp } = require('../apple');
const { applePayConfigService } = require('./config');

class PayButtonEventListenerService {
  constructor(
    documentCheckout,
    elements,
    callbackService,
    Selector,
  ) {
    this.documentCheckout = documentCheckout;
    this.elements = elements;
    this.callbackService = callbackService;
    this.Selector = Selector;
    this.isApplePayProcessing = false;
  }

  init(
    applePay = false,
    isWalletActive = false,
    stcPay = false,
    urPay = false
  ) {
    if (applePay) {
      this._attachApplePay(isWalletActive);
    }
    if (stcPay) {
      this._attachStcPay();
    }
    if (urPay) {
      this._attachUrPay();
    }
  }

  _attachApplePay(isWalletActive) {
    const applePayButton = this.documentCheckout.querySelector(
      '#' + this.elements.applePayButton
    );

    if (!applePayButton) {
      return;
    }

    applePayButton.addEventListener('click', async () => {
      // Prevent multiple simultaneous Apple Pay sessions
      if (this.isApplePayProcessing) {
        return;
      }

      this.isApplePayProcessing = true;

      try {
        const isValid = await this.Selector.validatePayment();
        if (isValid === false) {
          this.isApplePayProcessing = false;
          return; // stop execution if the validate promise rejects;
        }
        if (isWalletActive) {
          await _startApplePaySession();
        } else {
          await _openAppleWalletApp(applePayConfigService.get('merchant_id'));
        }
      } finally {
        this.isApplePayProcessing = false;
      }
    });
  }

  _attachStcPay() {
    const stcButton = this.documentCheckout.querySelector(
      '#' + this.elements.stcPayButton
    );
    if (!stcButton) {
      return;
    }

    stcButton.addEventListener('click', () => {
      this.Selector.validatePayment().then((isValid) => {
        if (!isValid) return;
        this.Selector.selectePayMethod(stcButton);
        this.Selector._mobilePay('stcPay');
      });
    });
  }

  _attachUrPay() {
    const urPayButton = this.documentCheckout.querySelector(
      '#' + this.elements.urPayButton
    );
    if (!urPayButton) {
      return;
    }

    urPayButton.addEventListener('click', () => {
      this.Selector.validatePayment().then((isValid) => {
        if (!isValid) {
          return;
        }
        this.Selector.selectePayMethod(urPayButton);
        this.Selector._mobilePay('urPay');
      });
    });
  }
}

module.exports = PayButtonEventListenerService;
